import React from 'react'
import SecondSurvelliance from '../components/Second survelliance audit/Second survelliance/SecondSurvelliance'

const SecondSurvellianceMainPage = () => {
  return (
    <div>
        <SecondSurvelliance/>
    </div>
  )
}

export default SecondSurvellianceMainPage
